import { __assign } from "tslib";
// DS9.4.1, DS9.4.1M
import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import { getCoverImageAttributes } from '../../Thumb/helpers';
import TierBadge from '@wix/da-ds/pkg/Badges/TierBadge';
import TierBadgeWithTooltip from '../../../TierBadgeWithTooltip';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import TextRenderer from '../../../TextRenderer';
import JournalViewer from '../../../DaEditorWrapper/Viewer/Journal';
import ReadingTime from '../_partials/ReadingTime';
import FeedCardLayout from '../_partials/FeedCardLayout';
import FeedCardTitle from '../_partials/FeedCardTitle';
import { DEFAULT_COVER_IMAGE_RESOLUTION_WIDTH, DEFAULT_COVER_IMAGE_RESOLUTION_HEIGHT, } from '../constants';
import draftTheme from '../../../DaEditorWrapper/Themes/Viewer/feedcard.scss';
import legacyTheme from '../feedcard.legacy.theme.scss';
import s from './Journal.scss';
var JournalFeedCardContents = function (_a) {
    var className = _a.className, deviation = _a.deviation, extraActions = _a.extraActions, withWatchOrSubscribeButton = _a.withWatchOrSubscribeButton, withCommentSuggestions = _a.withCommentSuggestions;
    var coverImage = getCoverImageAttributes({
        deviation: deviation,
        width: DEFAULT_COVER_IMAGE_RESOLUTION_WIDTH,
        height: DEFAULT_COVER_IMAGE_RESOLUTION_HEIGHT,
        allowHuge: true,
    });
    var _b = useSubscriptionTier(deviation), tier = _b.tier, isUserSubscribed = _b.isUserSubscribed, needsSubscription = _b.needsSubscription, isSubscribedButBlocked = _b.isSubscribedButBlocked;
    // maintain this so we can track when we can enable scroll restoration on duperbrowse
    var _c = useState(false), isLayoutReady = _c[0], setIsLayoutReady = _c[1];
    var onLayoutReady = useCallback(function () {
        setIsLayoutReady(true);
    }, []);
    return (React.createElement(FeedCardLayout, { className: className, deviation: deviation, extraActions: extraActions, isExpandable: true, 
        // we need to force the toggle button to be shown when unsubscribed/blocked
        // because the BE truncates text and the content is never tall enough to
        // cause the toggle to be shown using the normal means
        forceShowExpansionToggle: needsSubscription || isSubscribedButBlocked, withCommentControl: true, withFaveControl: true, withWatchOrSubscribeButton: withWatchOrSubscribeButton, withCommentSuggestions: withCommentSuggestions, onLayoutReady: onLayoutReady },
        coverImage && (React.createElement("div", { className: s['cover-image'], style: __assign({}, coverImage.style) },
            React.createElement("div", { className: s['fade'] }))),
        React.createElement("div", { className: s['title-area'] },
            !!tier &&
                (isUserSubscribed ? (React.createElement(TierBadge, { size: 40, className: s['tier-badge'] })) : (React.createElement(TierBadgeWithTooltip, { size: 40, className: s['tier-badge'], isLocked: !isUserSubscribed }))),
            React.createElement(FeedCardTitle, { className: s['title'], deviation: deviation, disableScrollRestoration: !isLayoutReady }),
            React.createElement("div", { className: s['reading-time'] },
                React.createElement(ReadingTime, { deviation: deviation }))),
        React.createElement(TextRenderer, { textContent: deviation.textContent, reactViewer: JournalViewer, viewerKey: deviation.deviationId, legacyTheme: "journal", fixedParagraph: false, 
            // if we don't turn off lazy loading here, tall images won't load src when this is collapsed
            disableLazyLoading: true, draftjsThemeOverride: draftTheme, className: classnames(s['content'], needsSubscription && s['show-at-least-two-lines'], legacyTheme['legacy'], legacyTheme['override'], draftTheme['override']) })));
};
JournalFeedCardContents.displayName = 'JournalFeedCardContents';
export default JournalFeedCardContents;
//# sourceMappingURL=Journal.js.map